import { action, computed, observable } from 'mobx'
import PT from 'prop-types'
import mkCombinedMessages from '@vimcar/shared-stores/mobx/user/Notifications/CombinedMessages'

export const MESSAGE_TYPES = ['bookingapproved', 'bookingcanceled']

const mkStore = (
  _request,
  props,
  { users }
) => {
  const store = observable({
    _notification: computed(() =>
      mkCombinedMessages({
        messageKeys: MESSAGE_TYPES,
        settings: users.self.notifications.getUser(),
      })
    ),

    showPushOptions: computed(() =>
      users.self.notifications.hasPushReceiver
    ),

    pushChecked: computed(() =>
      store._notification.channels.push
    ),
    emailChecked: computed(() =>
      store._notification.channels.email
    ),

    handleEmailChange: action(() => {
      const newState = !store.emailChecked
      props.onRequest(store._notification.update('email', newState))
    }),

    handlePushChange: action(() => {
      const newState = !store.pushChecked
      props.onRequest(store._notification.update('push', newState))
    }),
  })

  return store
}

mkStore.propTypes = {
  disabled: PT.bool,
  onRequest: PT.func.isRequired,
}

mkStore.contextTypes = {
  users: PT.object,
}

export default mkStore
